import { render, staticRenderFns } from "./DgoOnline.vue?vue&type=template&id=73de5d30"
import script from "./DgoOnline.vue?vue&type=script&lang=js"
export * from "./DgoOnline.vue?vue&type=script&lang=js"
import style0 from "./DgoOnline.vue?vue&type=style&index=0&id=73de5d30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports